import { Tab, TabBar } from './tabStyles';

interface LocalTabItem {
  title: string;
  id: string;
}

interface LocalTabsBarProps {
  tabs: LocalTabItem[];
  selectedId: string;
  onTabClick: (tab: LocalTabItem) => void;
}

export function LocalTabsBar({
  tabs,
  selectedId,
  onTabClick,
}: LocalTabsBarProps) {
  return (
    <TabBar>
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          selected={tab.id === selectedId}
          onClick={() => onTabClick(tab)}
        >
          {tab.title}
        </Tab>
      ))}
    </TabBar>
  );
}
